import Vue from 'vue'
import App from './App.vue'

import { store } from './store/store'

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

// IFRAME BUS LISTENER

export const EventBus = new Vue()

window.addEventListener('message', function (e) {
  console.log('1 - Receive Event MAIN LEVEL', e.origin)
  console.log('2 - Receive Event MAIN LEVEL', e.data)
  if (e.data.event === 'onClickPalletteIframe') {
    // console.log( '2 - Send data to COMPONENTS')
    EventBus.$emit('pallette-iframe', e.data.data)
  }
}, false)
